var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhereYourMoneyGoesAltuk = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 300 300"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#DEDBC9",
  d: "M250.773 40.99a144.996 144.996 0 0 1 22.645 192.495l-118.441-83.646z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#015d59",
  d: "M265.586 226.433a134.995 134.995 0 0 1-211.975 11.703 135.003 135.003 0 0 1 38.76-208.73A135 135 0 0 1 244.42 47.86L155 149z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F27B30",
  d: "M244.116 48.385a135.005 135.005 0 0 1 36.196 149.542l-125.921-48.674z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCD03",
  d: "M280.182 198.261a135 135 0 0 1-13.72 26.26l-112.071-75.268z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#D22267",
  d: "M266.428 224.617q-.947 1.407-1.929 2.791l-110.09-78.136z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M204.847 148.982c0 27.614-22.385 50-50 50s-50-22.386-50-50 22.386-50 50-50 50 22.386 50 50"
})));
export default SvgWhereYourMoneyGoesAltuk;